import Vue from 'vue'
import Router from 'vue-router'
import Home from '../view/home'
import aboutUs from '../view/aboutUs'
import product from '../view/product'
import service from '../view/service'
import customerCase from '../view/customerCase'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/service',
      name: 'service',
      component: service
    },
    {
      path: '/customerCase',
      name: 'customerCase',
      component: customerCase
    }
  ]
})
router.beforeEach((to, from, next) => {
  document.documentElement.scrollTop = 0
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js